import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { useDecision } from '@optimizely/react-sdk';
import { FeaturesList } from '../../common/constants/features';
import { CreateSpaceModal } from './CreateSpaceModal';
import { TemplateSelectionModal } from './TemplateSelectionModal';
export const CreateSpaceFromTemplateModal = ({ open, space = {}, onClose }) => {
    const [spaceCreationByTemplate] = useDecision(FeaturesList.SpaceCreationUsingTemplates);
    const [template, setTemplate] = useState(null);
    if (!open) {
        return null;
    }
    if (!spaceCreationByTemplate.enabled) {
        return _jsx(CreateSpaceModal, { open: open, onClose: onClose, space: space }, void 0);
    }
    if (!template) {
        return (_jsx(TemplateSelectionModal, { open: true, onClose: onClose, onSelect: template => {
                setTemplate(template);
            } }, void 0));
    }
    let entityProperties = {};
    try {
        entityProperties = JSON.parse((template === null || template === void 0 ? void 0 : template.entityProperties) || null);
    }
    catch (err) {
        console.error('Cannot parse template entityProperties', err);
    }
    return (_jsx(CreateSpaceModal, { open: true, onClose: onClose, space: {
            ...entityProperties,
            ...{ hidden: true, private: true },
            ...space,
        }, templateId: template === null || template === void 0 ? void 0 : template.id }, void 0));
};
//# sourceMappingURL=index.js.map